import { combineEpics } from 'redux-observable';
import getUserDetails from './getUserDetails';
import authenticateUser from './authenticateUser';
import getUserSession from './getUserSession';
import changePassword from './changePassword';
import logoutUser from './logoutUser';
import sessionExpired from './sessionExpired';

export default combineEpics(getUserDetails, authenticateUser, getUserSession, changePassword, logoutUser, sessionExpired);



// WEBPACK FOOTER //
// ./src/application/user/epic/index.ts